import logo from './logo.svg';
import './App.css';
import Routing from './routing/Routing';
import Marquee from "react-fast-marquee";
import OurGoals from './components/brands/Goals/OurGoals';
import { colors, Container } from '@mui/material';

function App() {
  return (
    <div className="App" >
      < >
      <Routing />
      </>
    </div>
  );
}

export default App;
